// The locale codes Play Console accepts for store listings, with display
// names. Source: Play Console "Supported languages" reference.
export interface PlayLocale { code: string; name: string }

export const PLAY_LOCALES: PlayLocale[] = [
  { code: 'af', name: 'Afrikaans' },
  { code: 'am', name: 'Amharic' },
  { code: 'ar', name: 'Arabic' },
  { code: 'az-AZ', name: 'Azerbaijani' },
  { code: 'be', name: 'Belarusian' },
  { code: 'bg', name: 'Bulgarian' },
  { code: 'bn-BD', name: 'Bangla' },
  { code: 'ca', name: 'Catalan' },
  { code: 'cs-CZ', name: 'Czech' },
  { code: 'da-DK', name: 'Danish' },
  { code: 'de-DE', name: 'German' },
  { code: 'el-GR', name: 'Greek' },
  { code: 'en-AU', name: 'English (Australia)' },
  { code: 'en-CA', name: 'English (Canada)' },
  { code: 'en-GB', name: 'English (United Kingdom)' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'en-SG', name: 'English (Singapore)' },
  { code: 'en-US', name: 'English (United States)' },
  { code: 'en-ZA', name: 'English (South Africa)' },
  { code: 'es-419', name: 'Spanish (Latin America)' },
  { code: 'es-ES', name: 'Spanish (Spain)' },
  { code: 'es-US', name: 'Spanish (United States)' },
  { code: 'et', name: 'Estonian' },
  { code: 'eu-ES', name: 'Basque' },
  { code: 'fa', name: 'Persian' },
  { code: 'fi-FI', name: 'Finnish' },
  { code: 'fil', name: 'Filipino' },
  { code: 'fr-CA', name: 'French (Canada)' },
  { code: 'fr-FR', name: 'French (France)' },
  { code: 'gl-ES', name: 'Galician' },
  { code: 'gu', name: 'Gujarati' },
  { code: 'hi-IN', name: 'Hindi' },
  { code: 'hr', name: 'Croatian' },
  { code: 'hu-HU', name: 'Hungarian' },
  { code: 'hy-AM', name: 'Armenian' },
  { code: 'id', name: 'Indonesian' },
  { code: 'is-IS', name: 'Icelandic' },
  { code: 'it-IT', name: 'Italian' },
  { code: 'iw-IL', name: 'Hebrew' },
  { code: 'ja-JP', name: 'Japanese' },
  { code: 'ka-GE', name: 'Georgian' },
  { code: 'kk', name: 'Kazakh' },
  { code: 'km-KH', name: 'Khmer' },
  { code: 'kn-IN', name: 'Kannada' },
  { code: 'ko-KR', name: 'Korean' },
  { code: 'ky-KG', name: 'Kyrgyz' },
  { code: 'lo-LA', name: 'Lao' },
  { code: 'lt', name: 'Lithuanian' },
  { code: 'lv', name: 'Latvian' },
  { code: 'mk-MK', name: 'Macedonian' },
  { code: 'ml-IN', name: 'Malayalam' },
  { code: 'mn-MN', name: 'Mongolian' },
  { code: 'mr-IN', name: 'Marathi' },
  { code: 'ms', name: 'Malay' },
  { code: 'ms-MY', name: 'Malay (Malaysia)' },
  { code: 'my-MM', name: 'Burmese' },
  { code: 'ne-NP', name: 'Nepali' },
  { code: 'nl-NL', name: 'Dutch' },
  { code: 'no-NO', name: 'Norwegian' },
  { code: 'pa', name: 'Punjabi' },
  { code: 'pl-PL', name: 'Polish' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)' },
  { code: 'rm', name: 'Romansh' },
  { code: 'ro', name: 'Romanian' },
  { code: 'ru-RU', name: 'Russian' },
  { code: 'si-LK', name: 'Sinhala' },
  { code: 'sk', name: 'Slovak' },
  { code: 'sl', name: 'Slovenian' },
  { code: 'sr', name: 'Serbian' },
  { code: 'sv-SE', name: 'Swedish' },
  { code: 'sw', name: 'Swahili' },
  { code: 'ta-IN', name: 'Tamil' },
  { code: 'te-IN', name: 'Telugu' },
  { code: 'th', name: 'Thai' },
  { code: 'tr-TR', name: 'Turkish' },
  { code: 'uk', name: 'Ukrainian' },
  { code: 'ur', name: 'Urdu' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'zh-CN', name: 'Chinese (Simplified)' },
  { code: 'zh-HK', name: 'Chinese (Hong Kong)' },
  { code: 'zh-TW', name: 'Chinese (Traditional)' },
  { code: 'zu', name: 'Zulu' },
];

const NAME_BY_CODE = new Map(PLAY_LOCALES.map((l) => [l.code.toLowerCase(), l.name]));

export function playLocaleName(code: string): string | null {
  return NAME_BY_CODE.get(code.toLowerCase()) ?? null;
}
